export const GOLD = '#C9A84C';

export const MOOD_CHIPS = [
  { id: 'relaxed', label: 'Relaxed', icon: '☁️', color: '#60a5fa', traits: { energyLevel: 20, tempoFeel: 25, vocalWeight: 55 } },
  { id: 'melancholy', label: 'Melancholy', icon: '🌧️', color: '#818cf8', traits: { energyLevel: 20, tempoFeel: 20, vocalWeight: 60 } },
  { id: 'reflective', label: 'Reflective', icon: '🪞', color: '#a78bfa', traits: { energyLevel: 25, tempoFeel: 30, vocalWeight: 55 } },
  { id: 'energetic', label: 'Energetic', icon: '⚡', color: '#ef4444', traits: { energyLevel: 85, tempoFeel: 80, vocalWeight: 50 } },
  { id: 'romantic', label: 'Romantic', icon: '❤️', color: '#f472b6', traits: { energyLevel: 35, tempoFeel: 35, vocalWeight: 70 } },
  { id: 'dark', label: 'Dark', icon: '🖤', color: '#6b7280', traits: { energyLevel: 40, tempoFeel: 40, vocalWeight: 45 } },
  { id: 'hopeful', label: 'Hopeful', icon: '🌅', color: '#fbbf24', traits: { energyLevel: 55, tempoFeel: 50, vocalWeight: 55 } },
  { id: 'dreamy', label: 'Dreamy', icon: '✨', color: '#c084fc', traits: { energyLevel: 25, tempoFeel: 20, vocalWeight: 45 } },
  { id: 'intimate', label: 'Intimate', icon: '🕯️', color: '#fb923c', traits: { energyLevel: 20, tempoFeel: 25, vocalWeight: 85 } },
  { id: 'epic', label: 'Epic', icon: '🏔️', color: '#34d399', traits: { energyLevel: 85, tempoFeel: 70, vocalWeight: 30 } },
];

export const ACTIVITY_CHIPS = [
  { id: 'working', label: 'Working', icon: '💻', traits: { energyLevel: 40, tempoFeel: 35, variety: 30, vocalWeight: 25, eraFlexibility: 70 } },
  { id: 'reading', label: 'Reading', icon: '📖', traits: { energyLevel: 20, tempoFeel: 20, variety: 25, vocalWeight: 20, eraFlexibility: 70 } },
  { id: 'cooking', label: 'Cooking', icon: '🍳', traits: { energyLevel: 60, tempoFeel: 55, variety: 50, vocalWeight: 50, eraFlexibility: 70 } },
  { id: 'driving', label: 'Driving', icon: '🚗', traits: { energyLevel: 70, tempoFeel: 65, variety: 55, vocalWeight: 50, eraFlexibility: 70 } },
  { id: 'late_night_listening', label: 'Late Night', icon: '🌙', traits: { energyLevel: 15, tempoFeel: 20, variety: 40, vocalWeight: 60, eraFlexibility: 70 } },
  { id: 'entertaining', label: 'Entertaining Guests', icon: '🥂', traits: { energyLevel: 50, tempoFeel: 50, variety: 45, vocalWeight: 55, eraFlexibility: 70 } },
  { id: 'background', label: 'Background', icon: '🔇', traits: { energyLevel: 30, tempoFeel: 35, variety: 20, vocalWeight: 30, eraFlexibility: 70 } },
  { id: 'deep_listening', label: 'Deep Listening', icon: '🎧', traits: { energyLevel: 40, tempoFeel: 40, variety: 60, vocalWeight: 50, eraFlexibility: 70 } },
];

export const MICRO_GENRES = {
  'Jazz': ['Bebop', 'Cool Jazz', 'West Coast Jazz', 'ECM Jazz', 'Fusion', 'Bossa Nova', 'Vocal Jazz', 'Hard Bop'],
  'Rock': ['Classic Rock', 'Yacht Rock', 'Americana', 'Progressive Rock', 'Blues Rock', 'Folk Rock'],
  'Electronic': ['Downtempo', 'IDM', 'House', 'Trip-Hop'],
  'Classical': ['Chamber', 'Orchestral', 'Minimalist', 'Piano Solo', 'Vocal'],
  'R&B / Soul': ['Neo Soul', 'Classic Soul', 'Funk', 'Motown'],
  'Folk / Acoustic': ['Acoustic Folk', 'Singer-Songwriter', 'Celtic', 'Bluegrass'],
};

export const INSTRUMENT_CHIPS = [
  { id: 'piano', label: 'Piano', icon: '🎹', vocal: false },
  { id: 'female_vocal', label: 'Female Vocal', icon: '👩‍🎤', vocal: true },
  { id: 'male_vocal', label: 'Male Vocal', icon: '👨‍🎤', vocal: true },
  { id: 'saxophone', label: 'Saxophone', icon: '🎷', vocal: false },
  { id: 'acoustic_guitar', label: 'Acoustic Guitar', icon: '🎸', vocal: false },
  { id: 'electric_guitar', label: 'Electric Guitar', icon: '🎸', vocal: false },
  { id: 'string_quartet', label: 'String Quartet', icon: '🎻', vocal: false },
  { id: 'trumpet', label: 'Trumpet', icon: '🎺', vocal: false },
  { id: 'bass', label: 'Bass', icon: '🎵', vocal: false },
  { id: 'drums', label: 'Drums', icon: '🥁', vocal: false },
  { id: 'violin', label: 'Violin', icon: '🎻', vocal: false },
  { id: 'cello', label: 'Cello', icon: '🎻', vocal: false },
];

export const DISCOVERY_MODES = [
  { id: 'safe_discovery', label: 'Safe Discovery', desc: 'Similar to what you love, just new artists', vibe: '🟢', traits: { variety: 40, eraFlexibility: 60 } },
  { id: 'adventurous', label: 'Adventurous', desc: 'Wider net, more surprises', vibe: '🟡', traits: { variety: 75, eraFlexibility: 80 } },
  { id: 'hidden_gems', label: 'Hidden Gems', desc: 'Deep cuts and underplayed tracks', vibe: '🟠', traits: { variety: 65, eraFlexibility: 70 } },
  { id: 'left_field', label: 'Left Field', desc: 'Genuinely unexpected territory', vibe: '🔴', traits: { variety: 95, eraFlexibility: 95 } },
];

export const FAVORITES_MODES = [
  { id: 'top_artists', label: 'My Top Artists', icon: '⭐', desc: 'Your most favorited musicians' },
  { id: 'most_played', label: 'My Most Played', icon: '🔁', desc: 'Artists you return to most' },
  { id: 'hidden_favorites', label: 'Hidden Favorites', icon: '💎', desc: "Artists you loved but haven't played lately" },
];

export const SEED_TILES = [
  { id: 'artist', icon: '🎤', label: 'Artist', desc: 'Start from a musician or band' },
  { id: 'song', icon: '🎵', label: 'Song', desc: 'Build around a specific track' },
  { id: 'mood', icon: '🌙', label: 'Mood', desc: 'Match the music to how you feel' },
  { id: 'activity', icon: '⚡', label: 'Activity', desc: "Music for what you're doing" },
  { id: 'genre', icon: '💿', label: 'Genre', desc: 'Explore a style of music' },
  { id: 'instrument', icon: '🎹', label: 'Instrument', desc: 'Let an instrument guide the music' },
  { id: 'discovery', icon: '🧭', label: 'Discovery', desc: "Find music you don't know yet" },
  { id: 'favorites', icon: '❤️', label: 'My Favorites', desc: 'More of what you already love' },
];

export const STATION_GRADIENTS = [
  'linear-gradient(135deg, #1a1a2e, #16213e, #0f3460)',
  'linear-gradient(135deg, #2d1b69, #11998e)',
  'linear-gradient(135deg, #654ea3, #eaafc8)',
  'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
  'linear-gradient(135deg, #141e30, #243b55)',
  'linear-gradient(135deg, #1f1c2c, #928dab)',
  'linear-gradient(135deg, #373b44, #4286f4)',
  'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
];

export function stationGradient(id) {
  let hash = 0;
  for (let i = 0; i < (id || '').length; i++) hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
  return STATION_GRADIENTS[Math.abs(hash) % STATION_GRADIENTS.length];
}

// ── Seasonality: Holiday catalog with Qobuz-verified music availability ──
// Audit date: March 2026 — all entries verified against Qobuz catalog search
export const HOLIDAY_CATALOG = [
  // Universal
  { id: 'christmas', name: 'Christmas', icon: '🎄', month: 12, day: 25, cultures: ['all'], searchTerms: ['Christmas', 'Noël', 'Weihnachten', 'Natale', 'Natal'], qobuzAlbums: 1000 },
  { id: 'new_years_eve', name: "New Year's Eve", icon: '🎆', month: 12, day: 31, cultures: ['all'], searchTerms: ['New Year celebration', 'Auld Lang Syne', 'Vienna New Year'], qobuzAlbums: 280 },
  { id: 'valentines', name: "Valentine's Day", icon: '💕', month: 2, day: 14, cultures: ['all'], searchTerms: ['Valentine love songs', 'romantic music'], qobuzAlbums: 212 },
  { id: 'hanukkah', name: 'Hanukkah', icon: '🕎', month: 12, day: null, cultures: ['all'], searchTerms: ['Hanukkah', 'Chanukah music'], qobuzAlbums: 1000, variable: true },
  { id: 'diwali', name: 'Diwali', icon: '🪔', month: 10, day: null, cultures: ['all'], searchTerms: ['Diwali', 'Festival of Lights Indian music'], qobuzAlbums: 1000, variable: true },
  // English
  { id: 'easter', name: 'Easter', icon: '🐣', month: 4, day: null, cultures: ['en'], searchTerms: ['Easter sacred', 'Easter choral', 'sacred music'], qobuzAlbums: 48, variable: true },
  { id: 'halloween', name: 'Halloween', icon: '🎃', month: 10, day: 31, cultures: ['en'], searchTerms: ['Halloween', 'spooky music', 'horror soundtrack'], qobuzAlbums: 1000 },
  { id: 'thanksgiving', name: 'Thanksgiving', icon: '🦃', month: 11, day: null, cultures: ['en'], searchTerms: ['Thanksgiving', 'grateful harvest'], qobuzAlbums: 1000, variable: true },
  { id: 'st_patricks', name: "St. Patrick's Day", icon: '☘️', month: 3, day: 17, cultures: ['en'], searchTerms: ['St Patrick Irish', 'Irish folk', 'Celtic music'], qobuzAlbums: 149 },
  // Spanish
  { id: 'dia_muertos', name: 'Día de los Muertos', icon: '💀', month: 11, day: 1, cultures: ['es'], searchTerms: ['Dia de los Muertos', 'Mexican folk', 'mariachi'], qobuzAlbums: 482 },
  { id: 'carnival_es', name: 'Carnaval', icon: '🎭', month: 2, day: null, cultures: ['es'], searchTerms: ['Carnival samba', 'Latin carnival', 'salsa'], qobuzAlbums: 330, variable: true },
  // French
  { id: 'fete_musique', name: 'Fête de la Musique', icon: '🎶', month: 6, day: 21, cultures: ['fr'], searchTerms: ['Fête musique', 'French chanson', 'musique française'], qobuzAlbums: 265 },
  { id: 'mardi_gras', name: 'Mardi Gras', icon: '🎭', month: 2, day: null, cultures: ['fr'], searchTerms: ['Mardi Gras', 'New Orleans jazz', 'Cajun music'], qobuzAlbums: 889, variable: true },
  // German
  { id: 'oktoberfest', name: 'Oktoberfest', icon: '🍺', month: 9, day: null, cultures: ['de'], searchTerms: ['Oktoberfest', 'German folk music', 'Bavarian'], qobuzAlbums: 759, variable: true },
  { id: 'karneval', name: 'Karneval', icon: '🎭', month: 2, day: null, cultures: ['de'], searchTerms: ['Karneval Fasching', 'German carnival'], qobuzAlbums: 73, variable: true },
  // Italian
  { id: 'carnevale', name: 'Carnevale di Venezia', icon: '🎭', month: 2, day: null, cultures: ['it'], searchTerms: ['Carnevale Venezia', 'Italian carnival'], qobuzAlbums: 56, variable: true },
  { id: 'sanremo', name: 'Festival di Sanremo', icon: '🎤', month: 2, day: null, cultures: ['it'], searchTerms: ['San Remo Italian', 'Sanremo festival'], qobuzAlbums: 29, variable: true },
  // Portuguese
  { id: 'carnaval_br', name: 'Carnaval', icon: '💃', month: 2, day: null, cultures: ['pt'], searchTerms: ['Carnaval samba', 'Brazilian carnival', 'axé'], qobuzAlbums: 330, variable: true },
  { id: 'festa_junina', name: 'Festa Junina', icon: '🔥', month: 6, day: null, cultures: ['pt'], searchTerms: ['Festa Junina forró', 'Brazilian folk', 'baião'], qobuzAlbums: 15, variable: true },
  // Japanese
  { id: 'hanami', name: 'Hanami', icon: '🌸', month: 3, day: null, cultures: ['ja'], searchTerms: ['cherry blossom sakura', 'Japanese spring', 'hanami'], qobuzAlbums: 74, variable: true },
  // Korean
  { id: 'seollal', name: 'Seollal (Lunar New Year)', icon: '🧧', month: 1, day: null, cultures: ['ko'], searchTerms: ['Korean traditional', 'Lunar New Year'], qobuzAlbums: 200, variable: true },
  // Chinese
  { id: 'chinese_new_year', name: 'Chinese New Year', icon: '🧨', month: 1, day: null, cultures: ['zh'], searchTerms: ['Chinese New Year', 'Chinese traditional'], qobuzAlbums: 473, variable: true },
  // Dutch
  { id: 'sinterklaas', name: 'Sinterklaas', icon: '🎅', month: 12, day: 5, cultures: ['nl'], searchTerms: ['Sinterklaas', 'Dutch holiday'], qobuzAlbums: 1000 },
  { id: 'carnival_nl', name: 'Carnaval', icon: '🎭', month: 2, day: null, cultures: ['nl'], searchTerms: ['Carnival', 'Dutch carnival'], qobuzAlbums: 73, variable: true },
];

export const SEASONALITY_CULTURES = [
  { code: 'all', label: 'All Cultures' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'zh', label: '中文' },
  { code: 'nl', label: 'Nederlands' },
];

export const DEFAULT_SEASONALITY = {
  enabled: false,
  seasonIntensity: 50,
  seasonCharacter: { spring: 50, summer: 50, autumn: 50, winter: 50 },
  holidayIntensity: 50,
  selectedCulture: 'all',
  selectedHolidays: ['christmas', 'new_years_eve'],
};

export function getCurrentSeason(date = new Date()) {
  const m = date.getMonth();
  if (m >= 2 && m <= 4) return 'spring';
  if (m >= 5 && m <= 7) return 'summer';
  if (m >= 8 && m <= 10) return 'autumn';
  return 'winter';
}

export function getActiveHolidays(selectedHolidays, date = new Date()) {
  const now = date.getTime();
  const windowMs = 21 * 24 * 60 * 60 * 1000; // 3-week window
  return HOLIDAY_CATALOG.filter(h => {
    if (!selectedHolidays.includes(h.id)) return false;
    if (!h.month) return false;
    const year = date.getFullYear();
    const holidayDate = new Date(year, h.month - 1, h.day || 15);
    if (Math.abs(now - holidayDate.getTime()) >= windowMs) return false;
    // Cross-year edge case: check previous/next year for holidays near year boundary
    const prevYear = new Date(year - 1, h.month - 1, h.day || 15);
    const nextYear = new Date(year + 1, h.month - 1, h.day || 15);
    return (
      Math.abs(now - holidayDate.getTime()) < windowMs ||
      Math.abs(now - prevYear.getTime()) < windowMs ||
      Math.abs(now - nextYear.getTime()) < windowMs
    );
  });
}

export function formatLastPlayed(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'Just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}h ago`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 7) return `${diffD}d ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
